"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkFallbackCriteria = void 0;
const taskStore_1 = require("../../../taskStore");
const taskSetup_1 = require("../../taskSetup");
const checkLocale_1 = require("./checkLocale");
const checkFallbackCriteria = (filterInputTrials = false) => {
    const data = taskSetup_1.jsPsych.data.get().filter({ assessment_stage: 'test_response' }).last(4);
    let incorrectTrials = data.filter({ correct: false });
    if (filterInputTrials) {
        incorrectTrials = incorrectTrials.filter({ trialMode: 'input' });
    }
    const numIncorrect = incorrectTrials.count();
    return numIncorrect >= 2 && (0, checkLocale_1.isEnglish)((0, taskStore_1.taskStore)().language);
};
exports.checkFallbackCriteria = checkFallbackCriteria;
